import { GPSPosition } from "../GPS-position";
import { COFRAC } from "./cofrac";
import { EEmplacementMesure } from "./enum/emplacement-mesure";
import { MesurePhysique } from "./mesure-physique";
import { Secchi } from "./secchi";
import { Sonde } from "./sonde";

export class PhysiqueChimieInSitu {
    SampleCode: string;
    Date: Date;

    EmplacementMesure: EEmplacementMesure;
    DistanceBerge: number;
    FacteurCorrection: number;
    // IsMandatory: boolean;

    Cofrac: COFRAC = new COFRAC();
    CofracTemperatureEau: COFRAC = new COFRAC();
    CofracPH: COFRAC = new COFRAC();
    CofracConductivite: COFRAC = new COFRAC();
    CofracOxygeneDissous: COFRAC = new COFRAC();
    CofracSaturationO2d: COFRAC = new COFRAC();

    GPSPosition: GPSPosition = new GPSPosition();
    Sonde: Sonde = new Sonde();
    MesurePhysiqueList: MesurePhysique[] = [];
    SecchiList: Secchi[] = []

    static mapFromJSON(json: any): PhysiqueChimieInSitu {
        const p = new PhysiqueChimieInSitu();
        p.SampleCode = json.sampleCode;
        p.Date = json.date;
        p.EmplacementMesure = json.emplacementMesure;
        p.DistanceBerge = json.distanceBerge;
        p.FacteurCorrection = json.facteurCorrection;

        if (json.cofrac) {
            p.Cofrac = COFRAC.mapFromJSON(json.cofrac)
        }
        if (json.cofracTemperatureEau) {
            p.CofracTemperatureEau = COFRAC.mapFromJSON(json.cofracTemperatureEau)
        }
        if (json.cofracPH) {
            p.CofracPH = COFRAC.mapFromJSON(json.cofracPH)
        }
        if (json.cofracConductivite) {
            p.CofracConductivite = COFRAC.mapFromJSON(json.cofracConductivite)
        }
        if (json.cofracOxygeneDissous) {
            p.CofracOxygeneDissous = COFRAC.mapFromJSON(json.cofracOxygeneDissous)
        }
        if (json.cofracSaturationO2d) {
            p.CofracSaturationO2d = COFRAC.mapFromJSON(json.cofracSaturationO2d)
        }

        if (json.gpsPosition) {
            p.GPSPosition = GPSPosition.mapFromJSON(json.gpsPosition);
        }

        if (json.sonde) {
            p.Sonde = Sonde.mapFromJSON(json.sonde);
        }
        if (json.secchiList) {
            p.SecchiList = json.secchiList.map(jsonItem => Secchi.mapFromJSON(jsonItem));
        }
        if (json.mesurePhysiqueList) {
            p.MesurePhysiqueList = json.mesurePhysiqueList.map(jsonItem => MesurePhysique.mapFromJSON(jsonItem));
        }
        return p;
    }
}